export function formatPhoneNumber(phoneNumber: string): string {
	if (!phoneNumber) {
		return "";
	}

	const cleaned = phoneNumber.replace(/[^\d+]/gu, "");

	if (cleaned.startsWith("+")) {
		const countryCode = cleaned.slice(0, 4);
		const number = cleaned.slice(4);

		const formatted = number.replace(/(?:\d{3})/gu, "$& ").trim();
		return `${countryCode} ${formatted}`;
	}

	return cleaned.replace(/(?:\d{3})/gu, "$& ").trim();
}

export function cleanPhoneNumber(phoneNumber: string): string {
	return phoneNumber.replace(/\s+/gu, "");
}
